import React, { useEffect } from 'react';
import Loading from './Loading';
import { INTERVAL_BEFORE_FORCE_PAGE_RELOADING } from '../constants';

export default function LoadingScreen() {
  useEffect(() => {
    const loadingInterval = setInterval(() => {
      location.reload();
    }, INTERVAL_BEFORE_FORCE_PAGE_RELOADING);
    return () => clearInterval(loadingInterval);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-screen h-screen z-50">
      <div className="absolute inset-0 bg-white opacity-50" />
      <div className="relative flex items-center justify-center h-full w-full">
        <Loading />
      </div>
    </div>
  );
}
